(function () {
  'use strict';

  var COLOR_MAP = {
    black: '#111111', white: '#ffffff', ivory: '#f5f0e6', cream: '#f2e9d8',
    beige: '#e3d5bd', camel: '#c19a6b', tan: '#d2b48c', navy: '#1b2a4a',
    charcoal: '#36454f', grey: '#8c8c8c', gray: '#8c8c8c', brown: '#5b3a29',
    olive: '#708238', burgundy: '#6d2130', khaki: '#c3b091', denim: '#4a6fa5'
  };

  var overlay, modal, closeBtn, thumbsEl, mainImg, titleEl, priceEl, fabricEl,
      sizeWrap, sizesEl, colorWrap, colorsEl, addBtn, addLabel, fullLink;

  var state = { product: null, selected: {}, requestToken: 0 };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function resizeImg(url, size) {
    if (!url) return url;
    var parts = url.split('?');
    var path = parts[0];
    var query = parts[1] ? '?' + parts[1] : '';
    var dot = path.lastIndexOf('.');
    if (dot === -1) return url;
    return path.slice(0, dot) + '_' + size + 'x' + path.slice(dot) + query;
  }

  function swatchColor(name) {
    var key = (name || '').toLowerCase().split(' ')[0];
    return COLOR_MAP[key] || '#cbbfa8';
  }

  function optionValues(product, index) {
    var seen = {};
    var values = [];
    product.variants.forEach(function (v) {
      var val = v.options[index];
      if (val && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });
    return values;
  }

  // Embedded `product | json` (Liquid drop) shapes images/featured_image as
  // objects ({ src, alt, width, height, ... }) instead of the plain URL
  // strings returned by /products/{handle}.js. Normalize both shapes to
  // flat URL strings so render() never needs to care where the data came
  // from (instant embedded JSON vs. legacy AJAX fallback).
  function imgSrc(img) {
    if (!img) return img;
    if (typeof img === 'string') return img;
    return img.src || img.url || null;
  }

  function normalizeProduct(raw) {
    if (!raw) return raw;
    var images = (raw.images || []).map(imgSrc).filter(Boolean);
    var featured = imgSrc(raw.featured_image) || images[0] || null;
    raw.images = images;
    raw.featured_image = featured;
    return raw;
  }

  function cacheEls() {
    overlay = overlay || qs('[data-quick-view-overlay]');
    modal = modal || qs('[data-quick-view-modal]');
    if (!modal) return false;

    closeBtn = closeBtn || qs('[data-quick-view-close]', modal);
    thumbsEl = thumbsEl || qs('[data-quick-view-thumbs]', modal);
    mainImg = mainImg || qs('[data-quick-view-main-image]', modal);
    titleEl = titleEl || qs('[data-quick-view-title]', modal);
    priceEl = priceEl || qs('[data-quick-view-price]', modal);
    fabricEl = fabricEl || qs('[data-quick-view-fabric]', modal);
    sizeWrap = sizeWrap || qs('[data-quick-view-size-wrap]', modal);
    sizesEl = sizesEl || qs('[data-quick-view-sizes]', modal);
    colorWrap = colorWrap || qs('[data-quick-view-color-wrap]', modal);
    colorsEl = colorsEl || qs('[data-quick-view-colors]', modal);
    addBtn = addBtn || qs('[data-quick-view-add]', modal);
    addLabel = addLabel || qs('[data-quick-view-add-label]', modal);
    fullLink = fullLink || qs('[data-quick-view-full-link]', modal);
    return true;
  }

  function bindStaticHandlersOnce() {
    if (!cacheEls()) return;
    if (closeBtn && !closeBtn.hasAttribute('data-qv-bound')) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
      closeBtn.setAttribute('data-qv-bound', '1');
    }
    if (overlay && !overlay.hasAttribute('data-qv-bound')) {
      overlay.addEventListener('click', close);
      overlay.setAttribute('data-qv-bound', '1');
    }
    if (addBtn && !addBtn.hasAttribute('data-qv-bound')) {
      addBtn.addEventListener('click', addToCart);
      addBtn.setAttribute('data-qv-bound', '1');
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Single source of truth for opening Quick View. Previously the trigger
  // button ALSO carried an inline onclick="window.openQuickView(...)" that
  // fired alongside this capturing listener, so every click kicked off two
  // concurrent /products/{handle}.js requests — the real cause of the
  // "very slow" modal. The trigger markup no longer has an inline handler,
  // so this is now the only place a click is handled.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var card = trigger.closest('[data-vesture-product-card]');
    var handle = trigger.getAttribute('data-product-handle');
    window.openQuickView(e, handle, card);
  }, true);

  function currentVariant() {
    var p = state.product;
    if (!p) return null;
    var found = p.variants.filter(function (v) {
      return p.options.every(function (name, i) { return v.options[i] === state.selected[name]; });
    });
    return found[0] || p.variants[0];
  }

  function render() {
    if (!cacheEls()) return;
    var p = state.product;
    var variant = currentVariant();

    titleEl.textContent = p.title;
    priceEl.textContent = money(variant.price);
    fullLink.href = p.url;

    if (p.type) {
      fabricEl.hidden = false;
      fabricEl.textContent = p.type;
    } else {
      fabricEl.hidden = true;
    }

    var images = (p.images && p.images.length) ? p.images : [p.featured_image];

    mainImg.src = resizeImg(images[0], 800);
    mainImg.alt = p.title;

    thumbsEl.innerHTML = '';
    images.slice(0, 6).forEach(function (src, i) {
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'va-quick-view__thumb' + (i === 0 ? ' is-active' : '');
      var img = document.createElement('img');
      img.src = resizeImg(src, 200);
      img.alt = '';
      img.loading = 'lazy';
      thumb.appendChild(img);
      thumb.addEventListener('click', function () {
        mainImg.src = resizeImg(src, 800);
        var active = thumbsEl.querySelector('.is-active');
        if (active) active.classList.remove('is-active');
        thumb.classList.add('is-active');
      });
      thumbsEl.appendChild(thumb);
    });

    var sizeIndex = -1;
    var colorIndex = -1;
    p.options.forEach(function (name, i) {
      var lower = name.toLowerCase();
      if (lower === 'size') sizeIndex = i;
      if (lower === 'color' || lower === 'colour') colorIndex = i;
    });

    if (sizeIndex > -1) {
      sizeWrap.hidden = false;
      sizesEl.innerHTML = '';
      optionValues(p, sizeIndex).forEach(function (val) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'va-quick-view__pill va-pill' + (state.selected[p.options[sizeIndex]] === val ? ' is-active' : '');
        pill.textContent = val;
        pill.addEventListener('click', function () {
          state.selected[p.options[sizeIndex]] = val;
          render();
        });
        sizesEl.appendChild(pill);
      });
    } else {
      sizeWrap.hidden = true;
    }

    if (colorIndex > -1) {
      colorWrap.hidden = false;
      colorsEl.innerHTML = '';
      optionValues(p, colorIndex).forEach(function (val) {
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'va-quick-view__swatch' + (state.selected[p.options[colorIndex]] === val ? ' is-active' : '');
        swatch.style.setProperty('--swatch-color', swatchColor(val));
        swatch.title = val;
        swatch.addEventListener('click', function () {
          state.selected[p.options[colorIndex]] = val;
          render();
        });
        colorsEl.appendChild(swatch);
      });
    } else {
      colorWrap.hidden = true;
    }

    if (variant.available) {
      addBtn.disabled = false;
      addLabel.textContent = 'Add to Bag — ' + money(variant.price);
    } else {
      addBtn.disabled = true;
      addLabel.textContent = 'Sold Out';
    }
  }

  function hydrate(product) {
    state.product = normalizeProduct(product);
    state.selected = {};
    product.options.forEach(function (name, i) {
      state.selected[name] = product.variants[0].options[i];
    });
    render();
  }

  // Legacy path: only used when a card has no embedded JSON (e.g. markup
  // rendered before this update, or a custom integration that hasn't
  // added data-product-json yet). Normal grid clicks never hit this.
  function loadFromNetwork(handle) {
    var token = ++state.requestToken;
    if (titleEl) titleEl.textContent = 'Loading…';
    if (priceEl) priceEl.textContent = '';

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Product fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (product) {
        if (token !== state.requestToken) return;
        hydrate(product);
      })
      .catch(function (err) {
        if (token !== state.requestToken) return;
        if (titleEl) titleEl.textContent = 'Unable to load product';
        if (window.console) console.error('[VESTURE Quick View]', err);
      });
  }

  function addToCart() {
    var variant = currentVariant();
    if (!variant || !variant.available) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.dispatchEvent(new CustomEvent('vesture:cart:changed'));
        close();
      });
  }

  function open() {
    if (!cacheEls()) return false;
    bindStaticHandlersOnce();
    overlay.hidden = false;
    modal.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      modal.classList.add('is-open');
    });
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('va-scroll-lock');
    return true;
  }

  function close() {
    cacheEls();
    if (!modal) return;
    overlay.classList.remove('is-visible');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('va-scroll-lock');
    setTimeout(function () {
      if (overlay) overlay.hidden = true;
      if (modal) modal.hidden = true;
    }, 320);
  }

  // card is the closest [data-vesture-product-card] element, which carries
  // the product's data-product-json attribute embedded at render time.
  // When present, we parse it synchronously and render immediately — zero
  // network round-trips, zero "Unable to load product" flashes. We only
  // fall back to the AJAX path if the embedded JSON is missing or fails
  // to parse.
  window.openQuickView = function (e, handle, card) {
    if (e) {
      if (typeof e.preventDefault === 'function') e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
    }
    if (!handle) return false;
    if (!open()) return false;

    state.requestToken++; // invalidate any in-flight legacy request

    var raw = card && card.getAttribute ? card.getAttribute('data-product-json') : null;
    if (raw) {
      try {
        var product = JSON.parse(raw);
        hydrate(product);
        return false;
      } catch (err) {
        if (window.console) console.error('[VESTURE Quick View] Failed to parse embedded product JSON, falling back to network', err);
      }
    }

    loadFromNetwork(handle);
    return false;
  };

  window.closeQuickView = function () {
    close();
  };

  function boot() {
    cacheEls();
    bindStaticHandlersOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
